import { render } from "./IreLiteralAreasEditing.vue?vue&type=template&id=6480a6cd&ts=true"
import script from "./IreLiteralAreasEditing.vue?vue&type=script&lang=ts"
export * from "./IreLiteralAreasEditing.vue?vue&type=script&lang=ts"

import "./IreLiteralAreasEditing.vue?vue&type=style&index=0&id=6480a6cd&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__